<script setup>
// Configura las URLs reales en .env (VUE_APP_APP_STORE_URL / VUE_APP_PLAY_STORE_URL).
// Mientras las fichas no estén publicadas, los enlaces apuntan a las tiendas.
const APP_STORE_URL = process.env.VUE_APP_APP_STORE_URL || 'https://apps.apple.com/'
const PLAY_STORE_URL = process.env.VUE_APP_PLAY_STORE_URL || 'https://play.google.com/store'
</script>

<template>
  <div class="flex flex-col gap-2.5 sm:flex-row">
    <a
      :href="APP_STORE_URL"
      target="_blank"
      rel="noopener noreferrer"
      class="group inline-flex items-center gap-3 rounded-xl border border-white/15 bg-white/[0.04] px-4 py-2.5 backdrop-blur transition-all duration-200 hover:-translate-y-0.5 hover:border-white/30 hover:bg-white/[0.08]"
    >
      <svg class="h-6 w-6 shrink-0 text-white" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M16.365 1.43c0 1.14-.42 2.2-1.26 3.18-.84.98-1.86 1.55-2.94 1.46-.13-1.11.42-2.27 1.24-3.2.82-.93 1.98-1.55 2.96-1.44zM20.9 17.06c-.5 1.16-.74 1.68-1.38 2.7-.9 1.44-2.17 3.24-3.74 3.25-1.4.01-1.76-.91-3.66-.9-1.9.01-2.3.91-3.7.9-1.57-.01-2.77-1.64-3.67-3.08-2.52-4.03-2.78-8.76-1.23-11.27 1.1-1.78 2.84-2.82 4.47-2.82 1.66 0 2.7.91 4.07.91 1.33 0 2.14-.91 4.06-.91 1.45 0 2.99.79 4.09 2.16-3.59 1.97-3.01 7.09.69 8.06z" />
      </svg>
      <span class="text-left leading-tight">
        <span class="block text-[8px] font-bold uppercase tracking-[0.16em] text-slate-400">Descargar en el</span>
        <span class="block text-sm font-black text-white">App Store</span>
      </span>
    </a>

    <a
      :href="PLAY_STORE_URL"
      target="_blank"
      rel="noopener noreferrer"
      class="group inline-flex items-center gap-3 rounded-xl border border-white/15 bg-white/[0.04] px-4 py-2.5 backdrop-blur transition-all duration-200 hover:-translate-y-0.5 hover:border-white/30 hover:bg-white/[0.08]"
    >
      <svg class="h-6 w-6 shrink-0 text-white" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M4.2 2.4a1.5 1.5 0 0 0-.8 1.35v16.5c0 .56.3 1.06.8 1.35l9.2-9.6-9.2-9.6Z" />
        <path d="M15.7 8.25 6.1 2.05c-.35-.2-.75-.2-1.05-.05l9.2 9.6 1.45-3.35Z" opacity=".75" />
        <path d="M15.7 15.75 14.25 12.4l-9.2 9.6c.3.15.7.15 1.05-.05l9.6-6.2Z" opacity=".55" />
        <path d="m15.7 8.25 3.8 2.2c.65.38.65 1.32 0 1.7l-3.8 2.2-1.45-3.35 1.45-2.75Z" opacity=".9" />
      </svg>
      <span class="text-left leading-tight">
        <span class="block text-[8px] font-bold uppercase tracking-[0.16em] text-slate-400">Disponible en</span>
        <span class="block text-sm font-black text-white">Google Play</span>
      </span>
    </a>
  </div>
</template>
